<template>
  <div class="container-fluid" id="product-bundle-ts">
    <div class="pt-5 w-100 text-center">
      <div class="row">
        <div class="col-12">
          <div class="d-flex align-items-center justify-content-center flex-md-row flex-column">
            <h1 class="font-avenir section-header text-center">
              I'm looking to
            </h1>
            <!-- Custom Dropdown -->
            <div class="dropdown show custom-dropdown">
              <button
                  class="btn btn-link dropdown-toggle"
                  type="button"
                  id="dropdownMenuButton"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  style="padding: 0 !important; outline: none; box-shadow: none;margin-bottom: 6px;"
              >
                <span class="title">{{ selectedValue }} <i class="fas fa-caret-down"></i></span>
              </button>

              <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                <button
                    v-for="option in options"
                    :key="option.id"
                    @click="handleClick(option.id)"
                    class="menu-list dropdown-item"
                    :style="{
                    'background-color':
                      option.id === selectedOption ? '#3592ff' : 'unset',
                    color: option.id === selectedOption ? 'white' : 'unset',
                  }"
                >
                  {{ option.value }}
                </button>
              </div>
            </div>
          </div>
          <span class="description" v-if="selectedOption===1"> Pay only for pre-qualified interviews curated by our algorithm, or download their cvs.</span>
          <span class="description" v-else>We make it flexible so that you choose which more works for you</span>

          <template v-if="selectedOption === 1">
            <div class="d-flex flex-row justify-content-center align-items-center flex-lg-row flex-column py-5 w-100">
              <MessagePrice v-if="selectedOption === 1"/>
              <CvDownloadPrice v-if="selectedOption === 1"/>
              <TalentRecruitmentPrice v-if="selectedOption === 1"/>
            </div>
          </template>
          <OnboardingPrice v-if="selectedOption === 2"/>
          <HrSuitePrice :feature-settings-data="featureSettings" v-if="selectedOption === 3"/>
          <DashboardPrice v-if="selectedOption === 4"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HrSuitePrice from './HrSuitePrice.vue';
import TalentRecruitmentPrice from './TalentRecruitmentPrice.vue';
import CvDownloadPrice from './CvDownloadPrice.vue';
import OnboardingPrice from './OnboardingPrice';
import DashboardPrice from './DashboardPrice';
import MessagePrice from './MessagePrice.vue';

export default {
  props : ['featureSettingsData'],
  components: { DashboardPrice, OnboardingPrice, HrSuitePrice, TalentRecruitmentPrice, CvDownloadPrice, MessagePrice},
  data () {
    return {
      options: [
        { id: 1, value: 'hire someone' },
        { id: 2, value: 'on-board someone' },
      ],
      selectedOption: 1,
      emptyLabel: 'Select',
    };
  },
  methods: {
    handleClick (i) {
      this.selectedOption = i;
      this.$store.dispatch('setLandingServiceOption', i);
    },
  },
  mounted () {
    let hrOption = { id: 3, value: 'use a HR software' };
    if (this.payrollEnabled) {
      hrOption = { id: 3, value: 'use a HR & Payroll software' };
    }
    this.options?.push(hrOption);
    this.options?.push({ id: 4, value: 'engage with my employees' });
  },
  computed: {
    selectedValue () {
      return this.options.filter(option => option.id === this.selectedOption)[0].value;
    },
    storedOption () {
      return this.$store.state.landingServiceSelected;
    },
    featureSettings () {
      return JSON.parse(this.featureSettingsData) ?? []
    },
    payrollEnabled () {
      return this.featureSettings?.payroll === 1 ?? false;
    },
  },

  watch: {
    storedOption () {
      this.selectedOption = this.storedOption;
    }
  },
};
</script>

<style lang="scss" scoped>
@mixin font-style {
  font-size: 32px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 60px;
}

#product-bundle-ts {
  .section-header {
    @include font-style;
    margin-bottom: 0;
  }

  .description {
    color: #606060;
    font-family: "Open Sans", sans-serif;
    font-size: 18px;
    letter-spacing: 0;
    line-height: 28px;
    text-align: center;
  }

  .custom-dropdown {
    margin-left: 8px;

    .title {
      color: #0db4e6;
      text-decoration: underline;
      @include font-style;
    }

    .dropdown-menu {
      border-radius: 0 0 8px 8px;
      padding: 0;
      //   padding: 0;
      //   display: flex;
      //   flex-direction: column;
      //   text-align: left;
    }

    .menu-list {
      font-size: 18px !important;
      line-height: 1.5 !important;
      font-weight: 400 !important;
      text-align: left;
      border-color: unset;
      @include font-style;

      &:last-child {
        border-radius: 0 0 8px 8px;
      }
    }
  }
}
</style>
